/** Flatten GET /api/user/llm-models — skips `_meta` and non-array provider entries. */
export function llmModelOptions(data: Record<string, unknown> | undefined): string[] {
  return Object.entries(data ?? {}).flatMap(([provider, ids]) => {
    if (provider.startsWith('_') || !Array.isArray(ids)) return [];
    return ids.map((id) => `${provider}/${String(id)}`);
  });
}
